import React, { useEffect, useState } from 'react';

interface SessionExpiredModalProps {
  onRelogin: () => void;
  onDismiss: () => void;
}

const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({ onRelogin, onDismiss }) => {
  const [countdown, setCountdown] = useState(30);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          onRelogin();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [onRelogin]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-[#0C2340] rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        <div className="flex items-center mb-4">
          <div className="flex-shrink-0">
            <svg className="h-12 w-12 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">
              Session Expired
            </h3>
            <p className="text-sm text-slate-400">
              Your login session has expired
            </p>
          </div>
        </div>

        <p className="text-slate-400 text-slate-300 mb-6">
          Please login again to continue using the application. You will be automatically redirected in{' '}
          <span className="font-bold text-primary-600">{countdown}</span> seconds.
        </p>

        <div className="flex justify-end space-x-3">
          <button
            onClick={onDismiss}
            className="px-4 py-2 text-sm font-medium text-slate-300 bg-slate-800/50 rounded-md hover:bg-slate-700 transition-colors"
          >
            Stay on Page
          </button>
          <button
            onClick={onRelogin}
            className="px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-md hover:bg-primary-700 transition-colors"
          >
            Login Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
